var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"page"},[(_vm.banner !== undefined)?_c('div',{staticClass:"banner"},[_c('img',{attrs:{"src":_vm.banner,"alt":""}})]):_vm._e(),_c('div',{staticClass:"content"},[_vm._t("default")],2)])}
var staticRenderFns = []

export { render, staticRenderFns }